<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">学职生涯</el-breadcrumb-item>
      <el-breadcrumb-item>{{ lists[0].title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="center">
          <div class="top_title">
            <div class="lefts"><img src="./images/left.png" alt="" /></div>
            <div class="centers">{{ lists[0].title }}测试题</div>
            <div class="rights"><img src="./images/right.png" alt="" /></div>
          </div>
        </div>
        <div class="body">
          <div class="body_title">
            <div class="alarm_clock">
              <img src="./images/alarm_clock.png" alt="" />
            </div>
            <div class="body_state">
              {{ lists[0].usesTime }}
            </div>
          </div>
          <div class="introduce">
            <div class="introduce_title">
              <div class="y"></div>
              <div class="introduce_state">测试介绍</div>
            </div>
            <div class="introduce_content">
              <p>
                {{ lists[0].introduce }}
              </p>
            </div>
          </div>
          <div class="introduce" v-if="lists[0].application">
            <div class="introduce_title">
              <div class="y"></div>
              <div
                v-if="lists[0].title == '中学生心理健康测验'"
                class="introduce_state"
              >
                测试应用
              </div>
              <div v-else class="introduce_state">选项参考</div>
            </div>
            <div class="introduce_content">
              <p>
                {{ lists[0].application }}
              </p>
            </div>
          </div>
          <div class="introduce">
            <div class="introduce_title">
              <div class="y"></div>
              <div class="introduce_state">测试须知</div>
            </div>
            <div class="introduce_content">
              <p>
                {{ lists[0].notice }}
              </p>
            </div>
          </div>
        </div>
        <div class="btn" @click="goMeasurement(lists[0].scaleId)">
          <button>开始测试</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBusScaleDescriptiont } from "@/api/home";
export default {
  name: "psychologyTesting",

  data() {
    return {
      lists: "",
    };
  },

  async mounted() {
    const resa = await GetBusScaleDescriptiont(this.$route.query.ScaleId);
    console.log(resa.result.busScaleDescriptions);
    this.lists = resa.result.busScaleDescriptions;
  },

  methods: {
    goMeasurement(ScaleId) {
      this.$router.push({
        path: "/psychologyMeasurement",
        query: {
          ScaleId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 1050px;
  background-color: #fff;
  margin-top: 10px;
  box-sizing: border-box;
  min-width: 1050px;
  .content {
    width: 100%;
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    box-sizing: border-box;
    .center {
      width: 100%;
      display: flex;
      margin-top: 48px;
      justify-content: center;
      .top_title {
        display: flex;
        align-items: center;
        .lefts {
          width: 40.21px;
          height: 21.21px;
        }
        .centers {
          font-size: 24px;
          color: #333;
          margin: 0 20px;
        }
        .rights {
          width: 40.21px;
          height: 21.21px;
        }
      }
    }
    .body {
      width: 100%;
      .body_title {
        display: flex;
        align-items: center;
        .alarm_clock {
          width: 15px;
          height: 15px;
          margin-right: 5px;
          img {
            width: 100%;
          }
        }
        .body_state {
          font-size: 16px;
          color: #ff3d00;
          font-weight: 600;
        }
      }
      .introduce {
        margin-top: 22px;
        .introduce_title {
          display: flex;
          align-items: center;
          .y {
            width: 14px;
            height: 14px;
            background: #3964e6;
            opacity: 1;
            border-radius: 50%;
            margin-right: 5px;
          }
          .introduce_state {
            font-size: 20px;
            color: #333;
            font-weight: bold;
          }
        }
        .introduce_content {
          margin-top: 9px;
          p {
            font-size: 18px;
            color: #666;
            margin-bottom: 10px;
          }
        }
      }
    }
    .btn {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 55px;
      button {
        width: 145px;
        height: 45px;
        background: #3964e6;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        border: 0;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
}
</style>
